export default __webpack_public_path__ + "static/Cart-NewArrivals-01bd72681e34bd8912a88a3d5aa03bbb.jpg";